import { Stack } from '@atlaskit/primitives';
import { DatabaseLayoutType } from '@databases/types/database/view';
import React, { FunctionComponent, useCallback } from 'react';

import useView from '../../hooks/useView';
import { ViewPanelSettingType } from '../../types/types';
import ViewSettingsConfigurationRow from '../viewSettingsConfigurationRow/ViewSettingsConfigurationRow';

import BoardLayoutOptions from './BoardLayoutOptions';
import CalendarLayoutOptions from './CalendarLayoutOptions';
import CardLayoutOptions from './CardLayoutOptions';
import TableLayoutOptions from './TableLayoutOptions';
import ViewSettingsLayoutTypePicker from './ViewSettingsLayoutTypePicker';

export interface ViewSettingsLayoutProps {
  FieldPicker: React.FunctionComponent<any>;
  contentId: string;
}

const ViewSettingsLayout: FunctionComponent<ViewSettingsLayoutProps> = ({
  FieldPicker,
  contentId,
}) => {
  const { view, setViewChange } = useView();
  const layout = view.settings.layout;

  const LayoutOptions = useCallback(() => {
    switch (layout.type) {
      case DatabaseLayoutType.TABLE:
        return <TableLayoutOptions />;
      case DatabaseLayoutType.CARD:
        return (
          <CardLayoutOptions
            onChange={setViewChange}
            FieldPicker={FieldPicker}
            contentId={contentId}
            layout={layout}
            source={'databaseViewSettingsPanel'}
          />
        );
      case DatabaseLayoutType.BOARD:
        return (
          <BoardLayoutOptions
            onChange={setViewChange}
            FieldPicker={FieldPicker}
            contentId={contentId}
            layout={layout}
            source={'databaseViewSettingsPanel'}
          />
        );
      case DatabaseLayoutType.CALENDAR:
        return (
          <CalendarLayoutOptions
            FieldPicker={FieldPicker}
            contentId={contentId}
            source={'databaseViewSettingsPanel'}
          />
        );
    }
  }, [layout, setViewChange, FieldPicker, contentId]);

  return (
    <Stack space="space.300">
      <ViewSettingsLayoutTypePicker isCompact={true} source="databaseViewSettingsPanel" />
      {
        <ViewSettingsConfigurationRow
          viewSetting={ViewPanelSettingType.LAYOUT}
          isButton={false}
          showIcon={false}
        />
      }
      <LayoutOptions />
    </Stack>
  );
};

export default ViewSettingsLayout;
